import $ from 'jquery';
import 'slick-carousel';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

export default function initHighlightScroll() {
//Scroll Hightlight Text Testimonial Block
  gsap.registerPlugin(ScrollTrigger, SplitText);

(function initTestimonials() {
  $('.testimonial-block').each(function () {
    const $block = $(this);
    const $wrap  = $block.find('.tst-wrap');
    const $bar   = $block.find('.tst-progress__bar');   // only exists when >1 item
    const hasSlick = $wrap.hasClass('is-slider');
    const slideCount = $wrap.find('.tst-slide').length;

    // ---- build the word-highlight for the <p> inside a given slide
    function buildHighlight($slide) {
      if (!$slide || !$slide.length) return;

      // revert previous SplitText on this slide
      const prevSplit = $slide.data('split');
      if (prevSplit && prevSplit.revert) prevSplit.revert();

      const base = $slide.find('.quote-text').get(0);
      const anim = $slide.find('.quote-text--animated').get(0);
      if (!base || !anim) return;

      // copy plain text into the animated clone
      anim.textContent = base.textContent;

      // split into words on the animated <p>, not the accessible one
      const split = new SplitText(anim, { type: 'words', wordsClass: 'line' });
      $slide.data('split', split);

      const words = split.words;
      gsap.set(words, { "--highlight-offset": "0%" });

      const prevST = $slide.data('st');
      if (prevST && prevST.kill) prevST.kill();

      const st = ScrollTrigger.create({
        trigger: $slide.find('.text').get(0),
        start: 'top 72%',
        end:   '+=80%',
        scrub: true,
        invalidateOnRefresh: true,

        onUpdate(self) {
          const split = $slide.data('split');
          if (!split) return;

          const words = split.words;

          const revealWindow = 1.35;
          const lead         = 0.10;
          const tail         = revealWindow - lead;

          const prog = gsap.utils.clamp(0, 1, self.progress / 0.5);
          const t = prog * (words.length + tail);

          const easeFill  = gsap.parseEase('power2.out');
          const easeAlpha = gsap.parseEase('sine.out');
          const smoothing = 0.25;

          for (let i = 0; i < words.length; i++) {
            const w = words[i];

            let raw = (t - i + lead) / revealWindow;
            raw = gsap.utils.clamp(0, 1, raw);

            const amt  = easeFill(raw);
            const aAim = easeAlpha(raw);

            const prevA   = parseFloat(w.dataset._wa || '0') || 0;
            const smoothA = prevA + (aAim - prevA) * smoothing;
            w.dataset._wa = smoothA.toFixed(4);

            w.style.setProperty('--highlight-offset', (amt * 100).toFixed(2) + '%');
            w.style.setProperty('--word-alpha',       smoothA.toFixed(3));
          }
        },

        onLeave(self) {
          const words = $slide.data('split')?.words || [];
          words.forEach(w => {
            w.style.setProperty('--highlight-offset', '100%');
            w.style.setProperty('--word-alpha', '1');
            w.dataset._wa = '1.0000';
          });
        },

        onLeaveBack(self) {
          const words = $slide.data('split')?.words || [];
          words.forEach(w => {
            w.style.setProperty('--highlight-offset', '0%');
            w.style.setProperty('--word-alpha', '0.2');
            w.dataset._wa = '0.2000';
          });
        }
      });

      $slide.data('st', st);
    }

    // ---- Animate the progress bar
    function setProgressTo(index, total) {
      if (!$bar.length || !total || total <= 1) return;
      const cur = Math.min(Math.max(index, 0), total - 1);
      const pct = ((cur + 1) / total) * 100;            // 1-based
      gsap.to($bar.get(0), { width: pct + '%', duration: 0.6, ease: 'power2.out' });
    }

    // SINGLE testimonial highlight
    if (!hasSlick || slideCount <= 1) {
      const $only = $wrap.find('.tst-slide').eq(0);
      buildHighlight($only);
      if ($bar.length) gsap.set($bar.get(0), { width: '100%' });
      ScrollTrigger.refresh();
      return;
    }

    // MULTIPLE testimonials
    $wrap.on('init', function (e, slick) {
      const cur = slick.currentSlide;
      const $current = $(slick.$slides[cur]);

      buildHighlight($current);
      setProgressTo(cur, slick.slideCount);
      ScrollTrigger.refresh();
    });

    $wrap.on('afterChange', function (e, slick, cur) {
      const $current = $(slick.$slides[cur]);

      buildHighlight($current);
      setProgressTo(cur, slick.slideCount);
      ScrollTrigger.refresh();
    });

    // Initialize slick
    if (!$wrap.hasClass('slick-initialized')) {
      $wrap.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        adaptiveHeight: true,
        prevArrow: $block.find('.tst-prev'),
        nextArrow: $block.find('.tst-next')
      });
    } else {
      const slick = $wrap.slick('getSlick');
      const cur   = slick.currentSlide;
      const $current = $(slick.$slides[cur]);
      buildHighlight($current);
      setProgressTo(cur, slick.slideCount);
      ScrollTrigger.refresh();
    }
  });
})();

window.addEventListener('load', () => ScrollTrigger.refresh());
}